var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiCardCheck } from '@/actions/CardActionsTs';
import { RegistrationCardViewSkeleton } from '@/components/pages/card/RegistrationCardView';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useBoolState } from '@/hooks/state/useBoolState';
import { RegistrationCardPage } from '@/pages/card/RegistrationCard/RegistrationCardPage';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { NOT_FOUND } from '@/utils/constants/api/responseCode';
import { loginPath } from '@/utils/router/links';
/**
 * 名刺登録（データ取得, 認証以外のアクセス制限）
 */
export const RegistrationCard = (props) => {
    var _a;
    const { match } = props;
    const token = ((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.token) || '';
    const history = useNavigate();
    // 名刺登録するユーザーの情報
    const [cardChecked, changeCardChecked] = useState(null);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    // ローディング制御
    const { boolState: isCheckLoading, changeFalse: stopCheckLoading, changeTrue: startCheckLoading, } = useBoolState();
    // トークン有効判定処理 実行
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            startCheckLoading();
            try {
                const action = apiCardCheck({ path: { token } }, {});
                const { payload } = yield wrapDispatch(dispatch, action);
                if (!unmountRef.current) {
                    changeCardChecked(payload);
                }
            }
            catch (error) {
                if (unmountRef.current) {
                    return;
                }
                if (Axios.isAxiosError(error)) {
                    // 該当トークンがない場合
                    if (((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) === NOT_FOUND) {
                        history.push(loginPath());
                    }
                }
            }
            finally {
                if (!unmountRef.current) {
                    stopCheckLoading();
                }
            }
        }))();
    }, [
        dispatch,
        history,
        startCheckLoading,
        stopCheckLoading,
        token,
        unmountRef,
    ]);
    if (isCheckLoading) {
        return _jsx(RegistrationCardViewSkeleton, {});
    }
    return _jsx(RegistrationCardPage, { cardChecked: cardChecked, token: token });
};
